import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import PropertyCard from "@/components/site/PropertyCard";
import Testimonials from "@/components/site/Testimonials";

export default function Properties() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState("All");

  useEffect(() => {
    api.get("/properties").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  const types = useMemo(() => ["All", ...new Set(items.map((p) => p.property_type).filter(Boolean))], [items]);
  const rows = items.filter((p) => type === "All" || p.property_type === type);

  return (
    <>
    <div className="container-x py-16" data-testid="properties-page">
      <p className="eyebrow">Real estate</p>
      <h1 className="mt-3 font-display text-4xl font-semibold tracking-tighter text-white sm:text-5xl">Properties</h1>
      <p className="mt-4 max-w-xl text-slate-400">Buy shares in individual properties and track your stake alongside your stocks.</p>
      <div className="chip-row mt-10">
        {types.map((t) => (
          <button key={t} onClick={() => setType(t)} data-testid={`properties-type-${t.toLowerCase().replace(/\s+/g, "-")}`}
            className={`rounded-full border px-4 py-3 text-xs transition-colors duration-200 sm:py-1.5 ${type === t ? "border-amber-600 bg-amber-600/10 text-amber-500" : "border-line text-slate-400 hover:text-white"}`}>
            {t}
          </button>
        ))}
      </div>
      <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {rows.map((p) => <PropertyCard key={p.id} property={p} />)}
      </div>
      {!rows.length && <p className="mt-12 text-slate-500" data-testid="properties-empty">No properties listed yet.</p>}
    </div>
    <Testimonials category="real_estate" />
    </>
  );
}
